module.exports = __webpack_public_path__ + "img/charity_box.04aacc31.svg";